export enum CARD_STATUS {
  GENERATED = 0,
  ACTIVATED = 1
};
